var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailScheduled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-clock-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6999 6.17896V11.7958C19.6063 10.8926 18.204 10.35 16.6748 10.35C13.1816 10.35 10.3498 13.1818 10.3498 16.675C10.3498 16.8688 10.3585 17.0606 10.3756 17.25H5.1749C3.58708 17.25 2.2998 15.9628 2.2998 14.375V6.17896L11.2084 11.4206C11.3883 11.5265 11.6115 11.5265 11.7914 11.4206L20.6999 6.17896Z",
    fill: "#7572F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.8249 2.30005C19.305 2.30005 20.5239 3.41854 20.6825 4.85642L11.4999 10.2579L2.31738 4.85642C2.47592 3.41854 3.69481 2.30005 5.17493 2.30005H17.8249Z",
    fill: "#7572F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.85 16.675C21.85 19.5331 19.5331 21.85 16.675 21.85C13.8169 21.85 11.5 19.5331 11.5 16.675C11.5 13.8169 13.8169 11.5 16.675 11.5C19.5331 11.5 21.85 13.8169 21.85 16.675ZM16.675 13.8C16.3575 13.8 16.1 14.0575 16.1 14.375V16.675C16.1 16.9925 16.3575 17.25 16.675 17.25H18.4C18.7175 17.25 18.975 16.9925 18.975 16.675C18.975 16.3575 18.7175 16.1 18.4 16.1H17.25V14.375C17.25 14.0575 16.9925 13.8 16.675 13.8Z",
    fill: "#7572F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailScheduled);
export default __webpack_public_path__ + "static/media/mail-scheduled.a8dcea8e405d3fa47d5e2fdb24e9d1f7.svg";
export { ForwardRef as ReactComponent };